export const firstWordCharacterRegex = /(?:^|\s|-|_)\S/g
export const licensePlatesRegex = /^[A-Z0-9\-\s]{1,20}$/i
export const numberSystem = /[^0-9.-]+/g
export const phoneRegExp = /[\s()-]*(\d[\s()-]*){10,20}/
export const roverDomainsRegex = /rover\.domains/g
export const symbolsRegex = /[\s|-|_]/g
export const urlStartsWithHttp = /^https?:\/\//
export const urlReplaceSubdomain = /^(https?:\/\/)?([^.]+\.)(.*)/
